import { connect } from 'react-redux';
import { Header } from 'components/HeaderAdmin';
import AdminActions from 'store/adminPanel/actions';

const mapStateToProps = state => {
  return {
    notifications: state.notifications.data,
    messagesHistory: state.messages.messagesHistory,
    profileDetails: state?.auth?.profile,
  };
};
const mapDispatchToProps = {
  logout: AdminActions.Creators.adminLogoutRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
